<template>
  <div>
    <AnimatedBg/>
    <GamePopUp v-if="!isLoading"/>
    <PreloaderView v-if="isLoading" :class="['preloader', { 'preloader--hidden': !isHidden }]"/>
    <router-view v-if="!isLoading" to="/"/>
    <SideMenu v-if="!isLoading"/>
    <FooterView v-if="!isLoading"/>
    <RegisterCta v-if="!isLoading"/>
    <AuthModal v-if="!isLoading"/>
    <AgeGate v-if="!isLoading"/>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import SideMenu from '@/views/SideMenu.vue';
import PreloaderView from '@/views/PreloaderView.vue';
import FooterView from '@/components/FooterView.vue';
import { useRouter } from "vue-router";
import GamePopUp from "@/base-components/GamePopUp.vue";
import AnimatedBg from "@/base-components/AnimatedBg.vue";
import AgeGate from "@/base-components/AgeGate.vue";
import AuthModal from "@/base-components/AuthModal.vue";
import RegisterCta from "@/base-components/RegisterCta.vue";

export default {
  components: {
    GamePopUp,
    AnimatedBg,
    AgeGate,
    AuthModal,
    RegisterCta,
    SideMenu,
    PreloaderView,
    FooterView
  },
  setup() {
    const isLoading = ref(true);
    const isHidden = ref(true);
    const router = useRouter();

    onMounted(async () => {
      const MIN_SPLASH = 1800;
      const start = Date.now();

      await document.fonts.ready;

      const elapsed = Date.now() - start;
      const remaining = Math.max(0, MIN_SPLASH - elapsed);

      setTimeout(() => {
        isHidden.value = false;
        setTimeout(() => {
          isLoading.value = false;
          router.push('/');
        }, 600);
      }, remaining);
    });

    return {
      isLoading,
      isHidden
    };
  }
};
</script>

<style lang="scss">
nav {
  padding: 30px;
  font-family: 'Open Sans', sans-serif;
  font-size: 25px;

  a {
    font-weight: bold;
    color: #2c3e50;
    text-decoration: none;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.app_menu {
  width: 100%;
  margin-top: 3px;
  margin-right: 3px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: flex-end;
  justify-content: flex-end;
}

.app_menu a {
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.85);
  width: 110px;
  height: 32px;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  background: rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(10px);
  transition: all 0.25s ease;

  &:hover {
    background: rgba(84, 243, 7, 0.14);
    border-color: rgba(84, 243, 7, 0.35);
    color: #fff;
  }
}

.preloader {
  opacity: 1;
  transition: opacity 0.6s ease;
}

.preloader--hidden {
  opacity: 0;
  pointer-events: none;
}
</style>
